import { categoryNormalize } from "./utils/normalize.utils";
import { useContext } from "react";
import {
  capitalize,
  useAnalytics,
  useAppNavigate,
} from "@commons-monorepo/index";
import { CATEGORY_EVENTS } from "./events";
import { CategoriesContext } from "./categories.context";

export const useCategories = (maxNumber = 8) => {
  const { data, partnerId, storeMetadata, theme } = useContext(CategoriesContext);
  const [logEvent] = useAnalytics({ storeMetadata });
  const navigate = useAppNavigate();
  const categories = data
    ?.slice(0, data?.length === maxNumber ? data.length : maxNumber)
    .map((category: any) => {
      return {
        className: "category",
        name: capitalize(category.name),
        image: category.image,
        onClick: () => {
          logEvent(CATEGORY_EVENTS.SELECT_CATEGORY, {
            source: category,
          });
          navigate(
            `categoria/${categoryNormalize(category?.id || category?.name)}`,
          );
        },
      };
    });
  if (data?.length >= maxNumber + 1) {
    categories.push({
      name: "Ver todas",
      className: "category view-more",
      image: "",
      onClick: () => {
        logEvent(CATEGORY_EVENTS.SELECT_SEE_ALL_CATEGORY);
        navigate("todos-los-productos");
      },
    });
  }

  return {
    data,
    categories,
    partnerId,
    theme,
  };
};
